import { Component, Input, input } from "@angular/core";
import { BackendApiService } from "../../services/backend-api.service";
import { RadialGaugeComponent } from "../../../components/client/radial-gauge/radial-gauge.component";
import { MatTooltip, MatTooltipModule } from "@angular/material/tooltip";
import { CommonModule } from "@angular/common";
import { GaugeChartComponent } from "../../../components/client/device-detail-nxt/gauge-chart-component/gauge-chart-component.component";
import { MatDialog } from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { DialogGraphscaleSettingsComponent } from "../../../components/client/dialog-graphscale-settings/dialog-graphscale-settings.component";
import { BaseUrlConstantsService } from "../../services/base-url-constants.service";

@Component({
  selector: "app-gauge-card",
  standalone: true,
  imports: [
    MatTooltip,
    MatTooltipModule,
    CommonModule,
    GaugeChartComponent,
  ],
  templateUrl: "./gauge-card.component.html",
  styleUrl: "./gauge-card.component.scss",
})
export class GaugeCardComponent {
  public sensorData = BaseUrlConstantsService.transformerApi;
  url = input({ required: true });
  @Input() type: string;
  @Input() title: string;
  @Input() metric_type: string;
  @Input() asset_id: number;
  data: any;
  gaugeShow: boolean = false;

  dataGadge: any=[];
  Itemsymbol: any;
  loading: boolean = true;

  //Graph Scale Setting Dialog Box Data.
  public settings: any;
  public GraphScaleSettingData: any;

  constructor(
    private service: BackendApiService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    if (this.type == "transformer") {
      this.getGaugeDataByID();
    }
  }
  //Radial-Gauge:: Oil Temperature Data.
  public async getGaugeDataByID() {
    this.service.getDataWithQuery(this.url()).then((sRes) => {
      let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

      if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
        let response = sensorRes.body;
        this.data = [];
        if (response.sensor != undefined) {
          if (response.sensor.length != 0) {
            this.dataGadge=response.sensor;
            console.log(this.dataGadge)
            let bottomLab = "";
            for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
              if (
                JSON.parse(this.dataGadge[mCount].value) === 0 &&
                this.dataGadge[mCount].needle === false
              ) {
                bottomLab = "N/A";
              } else {
                bottomLab =
                  JSON.parse(this.dataGadge[mCount].value) <= 0
                    ? "N/A"
                    : this.dataGadge[mCount].symbol === "C"
                    ? JSON.parse(this.dataGadge[mCount].value) +
                      " °" +
                      this.dataGadge[mCount].icon
                    : JSON.parse(this.dataGadge[mCount].value) +
                      " " +
                      this.dataGadge[mCount].icon;
              }

              this.Itemsymbol = this.dataGadge[mCount].symbol;
              let needleValueRes;
              if (this.dataGadge[mCount].symbol === "m/sec²") {
                needleValueRes = JSON.parse(this.dataGadge[mCount].value);
              } else if (this.dataGadge[mCount].symbol === "mm/sec") {
                needleValueRes = JSON.parse(this.dataGadge[mCount].value);
              } else if (this.dataGadge[mCount].symbol === "deg") {
                needleValueRes = JSON.parse(this.dataGadge[mCount].value);
              } else {
                //needleValueRes = JSON.parse(this.dataGadge[mCount].value);
                needleValueRes = JSON.parse(this.dataGadge[mCount].value);
              }

              let centerLab =
                JSON.parse(this.dataGadge[mCount].value) < 0
                  ? "N/A"
                  : JSON.parse(this.dataGadge[mCount].value);
              let arc_colors =
                this.dataGadge[mCount].needle === true
                  ? this.dataGadge[mCount].arcColors
                  : ["transparent", "transparent", "transparent"];
              let range_label =
                this.dataGadge[mCount].needle === true
                  ? this.dataGadge[mCount].rangelabel
                  : [];
              let arc_Delimiters =
                this.dataGadge[mCount].needle === true
                  ? this.dataGadge[mCount].arcDelimiters
                  : [];
              let value =
                JSON.parse(this.dataGadge[mCount].value) < 0
                  ? "N/A"
                  : JSON.parse(this.dataGadge[mCount].value);

              const dataObj = {
                // value:value,
                needleValue: needleValueRes,
                centralLabel: centerLab,
                outerNeedle: false,
                canvasWidth: 150,
                name: this.dataGadge[mCount].name,
                key: this.dataGadge[mCount].key,
                bottomLabel: bottomLab,
                hasneedle: this.dataGadge[mCount].needle,
                options: {
                  hasNeedle: this.dataGadge[mCount].needle,
                  needleColor: "black",
                  needleUpdateSpeed: "",
                  arcColors: arc_colors,
                  arcLabels: [] as string[],
                  arcDelimiters: this.dataGadge[mCount].arcDelimiters,
                  rangeLabel: range_label,
                  needleStartValue: 0,
                },
              };

              if (
                arc_Delimiters[0] < 100 &&
                arc_Delimiters[0] > 0 &&
                arc_Delimiters[1] > 0 &&
                arc_Delimiters[0] < arc_Delimiters[1] &&
                arc_Delimiters[1] < 100
              ) {
                let max = range_label[1] != null ? range_label[1] : 0;
                dataObj.options.arcLabels[0] =
                  sensorRes.body.rangeLabels.green;
                  dataObj.options.arcLabels[1] =
                  sensorRes.body.rangeLabels.yellow;
                let velocityG = sensorRes.body.rangeLabels.green;
                let velocityY = sensorRes.body.rangeLabels.yellow;
                let velocityR = max;
                dataObj.options.arcColors[0] =
                  "#72FF13";
                  dataObj.options.arcColors[1] =
                  "#FAA700";
                  dataObj.options.arcColors[2] =
                  "#ff2a1b";

                if (
                  dataObj.centralLabel <=
                  dataObj.options.arcLabels[0]
                ) {
                  // accelerationData.options.centralLabel=
                  dataObj.options.needleColor =
                    "#72FF13";
                } else if (
                  dataObj.centralLabel >
                  dataObj.options.arcLabels[0] &&
                  dataObj.centralLabel <=
                  dataObj.options.arcLabels[1]
                ) {
                  dataObj.options.needleColor =
                    "#FAA700";
                } else {
                  dataObj.options.needleColor =
                    "#ff2a1b";
                }

                this.data.push(
                  dataObj
                );
                setTimeout(() => {
                  this.loading = false;
                }, 1000);

                this.gaugeShow = true;
              }
            }
          }
        }
      }
    });
  }

  // ------------------------------------------------SETTING MODAL STARTS --------------------------------------------------------
  //Graph Scale Setting Dialog Box Code Start.
  openExformerGraphSettingsDialog(metric_type: string, asset_id: number): void {
    this.getExformerGraphScaleSettingsDataByID(metric_type, asset_id);

    this.getExformerGraphScaleSettingsDataByID(metric_type, asset_id)
      .then((data: any) => {
        //set data into GraphScaleSettingData variable.
        this.GraphScaleSettingData = [];
        let response = data.body;
        this.GraphScaleSettingData.push({
          metric_type: metric_type,
          asset_id: asset_id,
          green: response.threshold_1,
          yellow: response.threshold_2,
          red: response.threshold_3,
          max_value: response.max_value,
          min_value: response.base_value,
        });
        console.log(this.GraphScaleSettingData);
        //Open Dialog Box.
        const dialogRef = this.dialog.open(DialogGraphscaleSettingsComponent, {
          width: "800px",
          data: this.GraphScaleSettingData, // Pass settings data to dialog
        });

        //Closed Dialog box
        dialogRef.afterClosed().subscribe((updatedSettings) => {
          if (updatedSettings) {
            this.saveSettings(updatedSettings);
            this.ngOnInit();

            // Show toast message
            this._snackBar.open(
              "Settings has been saved successfully.",
              "Dismiss",
              {
                duration: 2000,
                horizontalPosition: "center",
                verticalPosition: "top" as MatSnackBarVerticalPosition, // Explicitly specify the type
                panelClass: ["custom-snackbar"],
              }
            );
          }
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        // Handle error here
      });
  }

  public async getExformerGraphScaleSettingsDataByID(
    metric_type: string,
    asset_id: number
  ): Promise<any> {
    try {
      const sensorRes = await this.service
        .getDataWithQuery(
          `${this.sensorData}/etxformer-graph-scale-settings/${metric_type}/${asset_id}`
        )
        .then((res) => {
          return res;
        });
      const sensorBody = JSON.parse(JSON.stringify(sensorRes)).data;

      if (sensorBody && Object.keys(sensorBody).length !== 0) {
        return sensorBody;
      } else {
        throw new Error("No data found in sensor response");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }

  saveSettings(updatedSettings: any): void {
    // Implement saving logic using DataService
    // Example:
    this.service
      .saveSettings(
        this.sensorData + "/etxformer-graph-scale-settings-save",
        updatedSettings
      )
      .then(
        () => {
          console.log("Settings saved successfully");
        },
        (error) => {
          console.error("Error saving settings:", error);
        }
      );
  }
}
